import { servObj } from './init_glob';
import {
    applyRoofColor,
    applyFasadTexture,
    applyDrainageSystemColor,
    applyWindowsDoorsColor,
    applyPlinthTexture,
    checkHouseInputs,
} from './house_configurate';

import {applyFenceTexture, applyFenceType, checkFenceInputs} from "./fence_configurate.js"

import { applyTile } from './tile_configurate';
import { updateCart } from './cart';
import { reCreateGroupMenu } from './template';
import { hideLoaderElement, showLoaderElement } from './loaderElement.js';
import { closeModal } from './modals.js';

const applySavedData = (savedData) => {
    servObj.isInfoWindowHide = undefined
    showLoaderElement(true);
    applyRoofColor(savedData.house.roofColor);
    applyFasadTexture(savedData.house.fasadTexture, false);
    applyDrainageSystemColor(savedData.house.drainageSystemColor);
    applyWindowsDoorsColor(savedData.house.windowsDoorsColor);
    applyPlinthTexture(savedData.house.plinthTexture, false);
    checkHouseInputs();

    applyFenceTexture(savedData.fence.textureName, savedData.fence.rusTextureName, false)
    applyFenceType(savedData.fence.type)

    checkFenceInputs()

    servObj.savedData = savedData;
    servObj.tile.activeTilePattern = savedData.tile.activeTilePattern;
    servObj.tile.activeFacture = savedData.tile.activeFacture;
    servObj.tile.activeCollection = savedData.tile.activeCollection;
    servObj.tile.activeDepth = savedData.tile.activeDepth;
    servObj.tile.activeColor = savedData.tile.activeColor;
    servObj.tile.activeGroupName = savedData.tile.activeGroupName;

    servObj.fence.textureName = savedData.fence.textureName
    servObj.fence.rusTextureName = savedData.fence.rusTextureName
    servObj.fence.type = savedData.fence.type

    //console.log(savedData)

    servObj.isApplySaved = true

    applyTile(() => hideLoaderElement(true), false);
    reCreateGroupMenu(savedData.tile.activeGroupName);

    document.querySelector(`#paving-slabs__${savedData.tile.activeGroupName}`).checked = true;
    document.querySelector(`#paving-slabs__pattern_${savedData.tile.activeTilePattern.pathName}`).checked = true;
    document.querySelector(`#facture option[value="${savedData.tile.activeFacture.pathName}"]`).selected = true;
    document.querySelector(`#paving-slabs__collection_${savedData.tile.activeCollection.pathName}`).checked = true;
    document.querySelector(`#paving-slabs__thickness_${savedData.tile.activeDepth}`).checked = true;
    document.querySelector(`#option-color input[value="${savedData.tile.activeColor}"]`).checked = true;

    servObj.cart = savedData.cart;
    updateCart();
};

document.querySelector('#save-project').addEventListener('pointerdown', () => {
    const saveData = {};
    saveData.house = servObj.house;
    saveData.cart = servObj.cart;
    saveData.tile = servObj.tile;
    saveData.fence = servObj.fence;
    let a = document.createElement('a');
    const input = document.querySelector('#file-name-input');
    a.download = input && input.value !== '' ? `${input.value}.json` : 'Porevit.json';
    let blob = new Blob([JSON.stringify(saveData)]);
    let url = URL.createObjectURL(blob);
    a.href = url;
    a.click();
    URL.revokeObjectURL(url);
    a.remove();
});

let file;
document.querySelector('#upload-project').addEventListener('pointerdown', () => {
    const fileInputBlock = document.querySelector('.file-upload');
    const fileInput = fileInputBlock.querySelector('.file-input');
    const fileNameText = fileInputBlock.querySelector('.file-name');

    const file = fileInput.files[0];

    if (!file) {
        fileNameText.textContent = 'Выберите файл!';
        fileNameText.classList.add('input_error');
        fileInputBlock.classList.add('input_error');
        return;
    }

    const isJsonType = file.type === 'application/json';
    const isJsonExtension = file.name.toLowerCase().endsWith('.json');

    if (!isJsonType || !isJsonExtension) {
        fileNameText.textContent = 'Формат только .json';
        fileNameText.classList.add('input_error');
        fileInputBlock.classList.add('input_error');
        return;
    }

    closeModal('upload-project-modal');

    let reader = new FileReader();
    reader.addEventListener('load', function (e) {
        const savedData = JSON.parse(e.target.result);
        applySavedData(savedData);
    });
    reader.readAsText(file);
});

document.querySelector('.file-upload .file-input').addEventListener('change', (e) => {
    file = e.target.files[0];
});
